import { jsx as _jsx } from "react/jsx-runtime";
import { v4 as uuidv4 } from "uuid";
import { CoreIcon } from "./core-icon";
import { CoreWhiteIcon } from "./core-white";
import { CRMIcon } from "./crm-icon";
import { CRMWhiteIcon } from "./crm-white";
import { MarketingIcon } from "./marketing-icon";
import { ProjectManagementIcon } from "./project-management-icon";
import { SoftwareIcon } from "./software-icon";
import { SoftwareWhiteIcon } from "./software-white";
import { ServiceIcon } from "./service-icon";
const productNameToIconMap = {
    core: CoreIcon,
    projectManagement: ProjectManagementIcon,
    software: SoftwareIcon,
    marketing: MarketingIcon,
    crm: CRMIcon,
    service: ServiceIcon,
    coreWhite: CoreWhiteIcon,
    softwareWhite: SoftwareWhiteIcon,
    crmWhite: CRMWhiteIcon
};
export const ProductIcon = ({ product })=>{
    const IconComponent = productNameToIconMap[product];
    return IconComponent ? /*#__PURE__*/ _jsx(IconComponent, {
        id: uuidv4()
    }) : null;
};
